import React from 'react';
import { Link } from 'react-router-dom';
import { X, LogOut } from 'lucide-react';

const CandidateMobileMenu = ({ setMobileMenuOpen }) => {
  return (
    <div className="fixed inset-0 z-50 bg-white">
      <div className="flex flex-col h-full p-6">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-xl font-bold text-black">Menu</h2>
          <button 
            onClick={() => setMobileMenuOpen(false)}
            className="p-2 text-black hover:bg-gray-100 rounded-full"
          >
            <X size={24} />
          </button>
        </div>
        
        <nav className="flex-1">
          <ul className="space-y-4">
            <li>
              <Link to="/candidate/profile" className="flex items-center text-black text-base">
                Profile
              </Link>
            </li>
            <li>
              <Link to="/candidate/messages" className="flex items-center text-black text-base">
                Messages
                <span className="ml-2 bg-yellow-400 text-black text-xs px-2 py-0.5 rounded-full">3</span>
              </Link>
            </li>
            <li>
              <Link to="/jobs" className="flex items-center text-black text-base">
                Jobs
              </Link>
            </li>
          </ul>
        </nav>
        
        <div className="mt-auto pt-6 border-t border-gray-200">
          <Link to="/logout" className="flex items-center text-black text-base">
            <LogOut className="mr-2" size={18} />
            Logout
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CandidateMobileMenu;
